import React from 'react';
import { Typography, Box} from '@mui/material';

export const ContentContainer = ({ children, title, sx }) => {
	return (
			<Box
				sx={{
					height: 'fit-content',
					// background: '#F2ECFF',
          background:"#C6C6C6",
					...sx,
					color: 'white',
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					flexDirection: 'column',
					padding: '1.5em',
          // borderRight:'1px dashed gray'
				}}
			>
				<Typography
					color="black"
					variant="h6"
					borderBottom={'1px solid black'}
					fontFamily="epilogue"
					fontWeight="300"
				>
					{title}
				</Typography>
				{children}
			</Box>
	);
};
